import React, { useRef, useCallback, useState, useEffect } from "react";
import { FormHandles } from "@unform/core";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";

import { getValidationErros, cleanNumber } from "../../../Utils";
import { useCreateProposal, useSendStepProposal } from "../services";
import { ScreensEnum } from "../../Feedback/Feedback.controller";

import { UserDataScreen, UserDataScreenProps } from "./UserData.screen";
import {
  reduceFormErrors,
  validateInput,
  onChange,
  formatFieldBirhdate,
  formatFieldCellphone,
  formatFieldUsername,
  onChangePassword,
  useHandleStepProposal,
  handleErrorMessage,
} from "./services";

export const UserDataController = () => {
  const formRef = useRef<FormHandles>(null);
  const countdownRef: any = useRef(null);

  const { createProposal } = useCreateProposal();
  const { sendStepProposal } = useSendStepProposal();
  const { handleSendStepProposal } = useHandleStepProposal();

  const history = useHistory();

  const [showModal, setShowModal] = useState(false);

  const [proposalId, setProposalId] = useState<null | string>(null);
  const [stepBirthdateId, setStepBirthdateId] = useState<null | string>(null);
  console.log("stepBirthdateId", stepBirthdateId);
  const [stepCellphoneId, setStepCellphoneId] = useState<null | string>(null);
  const [stepUsernameId, setStepUsernameId] = useState<null | string>(null);

  console.log("stepCellphoneId", stepCellphoneId);
  const [password, setPassword] = useState("");

  const [disabledCPF, setDisabledCPF] = useState(false);
  const [disabledBirthdate, setDisabledBirthdate] = useState(true);
  const [disabledCellphone, setDisabledCellphone] = useState(true);
  const [disabledUsername, setDisabledUsername] = useState(true);
  const [disabledPassword, setDisabledPassword] = useState(true);

  const [loadingResendToken, setLoadingResendToken] = useState(false);
  const [loadingSendPassword, setLoadingSendPassword] = useState(false);

  const [inputTokens, setInputTokens] = useState({
    "token-1": "",
    "token-2": "",
    "token-3": "",
    "token-4": "",
    "token-5": "",
    "token-6": "",
    error: "",
    loading: false,
    disabledSubmit: true,
  });

  const clearInputsToken = (): void => {
    setInputTokens({
      ...inputTokens,
      "token-1": "",
      "token-2": "",
      "token-3": "",
      "token-4": "",
      "token-5": "",
      "token-6": "",
      error: "",
    });
  };

  useEffect(() => {
    if (
      inputTokens.disabledSubmit === true &&
      inputTokens["token-1"] &&
      inputTokens["token-2"] &&
      inputTokens["token-3"] &&
      inputTokens["token-4"] &&
      inputTokens["token-5"] &&
      inputTokens["token-6"]
    ) {
      setInputTokens({ ...inputTokens, disabledSubmit: false });
      return;
    }

    if (
      inputTokens.disabledSubmit === false &&
      (!inputTokens["token-1"] ||
        !inputTokens["token-2"] ||
        !inputTokens["token-3"] ||
        !inputTokens["token-4"] ||
        !inputTokens["token-5"] ||
        !inputTokens["token-6"])
    ) {
      setInputTokens({ ...inputTokens, disabledSubmit: true });
      return;
    }
  }, [inputTokens]);

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = (): void => {
    setShowModal(true);
  };

  const setInputToken = (name: string, value = "") => {
    if (name) {
      setInputTokens({ ...inputTokens, [name]: value });
    }
  };

  const errorMessage =
    "Não foi possível prosseguir com o cadastro. Por favor, tente novamente.";

  const focusInput = useCallback(
    (nameInput: string) => () => {
      const input = formRef.current?.getFieldRef(nameInput);
      input?.focus();
    },
    []
  );

  const handleSubmitCPF = useCallback(async () => {
    const fields = formRef?.current?.getData();

    try {
      await validateInput({ name: "cpf" })(fields);

      formRef.current?.setErrors(reduceFormErrors(formRef, { cpf: "loading" }));

      const response = await createProposal({
        variables: { document: cleanNumber(fields?.cpf || "") },
      });

      const CreateProposal = response?.data?.CreateProposal;
      const status = CreateProposal?.status;
      const statusReason = CreateProposal?.status_reason;
      const step = CreateProposal?.step;
      const id = CreateProposal?.id;

      console.log(response);

      if (status === "identity_analysis" && step === "awaiting_birthdate") {
        formRef.current?.setErrors(
          reduceFormErrors(formRef, { cpf: "success" })
        );

        setProposalId(id);
        setDisabledBirthdate(false);
        focusInput("birthdate")();
        return;
      }

      if (
        (status === "approved_topups" && step === "approved_topups") ||
        statusReason === "document_already_exists"
      ) {
        history.push({
          pathname: "/feedback",
          state: { type: ScreensEnum.ALREADY_REGISTERED_USER },
        });
        return;
      }

      handleErrorMessage({
        errorSuccess: response,
        fieldName: "cpf",
        path: "CreateProposal",
        formRef,
      });
    } catch (error: any) {
      console.log({ ...error });
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErros(error);
        formRef.current?.setErrors(reduceFormErrors(formRef, errors));
        return;
      }

      handleErrorMessage({
        errorCatch: error,
        fieldName: "cpf",
        formRef,
      });
    }
  }, [createProposal, focusInput, history]);

  const handleResendToken = async () => {
    try {
      const variables = {
        proposal_id: proposalId,
        step: "resend_cellphone_number_validation_token",
      };

      setLoadingResendToken(true);

      const response = await sendStepProposal({
        variables,
      });
      console.log(response);
      countdownRef?.current?.resetCounter();

      clearInputsToken();
      setLoadingResendToken(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSendStepProposalToken = useCallback(async () => {
    try {
      setInputTokens({ ...inputTokens, loading: true });

      const token =
        inputTokens?.["token-1"] +
        inputTokens?.["token-2"] +
        inputTokens?.["token-3"] +
        inputTokens?.["token-4"] +
        inputTokens?.["token-5"] +
        inputTokens?.["token-6"];

      if (token?.length !== 6) {
        setInputTokens({ ...inputTokens, loading: false });
        return;
      }

      const variables = {
        proposal_id: proposalId,
        step: "cellphone_number_validation",
        token,
      };

      const response = await sendStepProposal({
        variables,
      });

      const SendProposalStep = response?.data?.SendProposalStep;
      const status = SendProposalStep?.status;
      const step = SendProposalStep?.step;

      if (status === "identity_analysis" && step === "awaiting_username") {
        closeModal();
        setInputTokens({ ...inputTokens, loading: false });
        setDisabledUsername(false);
        setDisabledCellphone(true);
        setTimeout(focusInput("username"), 1000);
        return;
      }
    } catch (error: any) {
      console.log({ ...error });
      const statusReason =
        error?.graphQLErrors?.[0]?.extensions?.response?.body?.code;
      let message = "";

      if (statusReason === "invalid_token_error") {
        message = "Código inválido";
      } else if (statusReason === "token_expired") {
        message = "O código expirou";
      }

      setInputTokens({
        ...inputTokens,
        loading: false,
        error: message,
      });

      console.log({ ...error });
    }
  }, [focusInput, inputTokens, proposalId, sendStepProposal]);

  const handleSendStepProposalPassword = async () => {
    try {
      const fields = formRef?.current?.getData();
      await validateInput({ name: "all" })(fields);

      const variables = {
        proposal_id: proposalId,
        step: "fill_in_password",
        password: fields?.password,
      };

      const response = await sendStepProposal({
        variables,
      });

      console.log(response);

      const SendProposalStep = response?.data?.SendProposalStep;
      const status = SendProposalStep?.status;
      const step = SendProposalStep?.step;

      if (
        status === "identity_analysis" &&
        step === "awaiting_identity_analysis"
      ) {
        return true;
      }

      handleErrorMessage({
        errorSuccess: response,
        fieldName: "password",
        path: "SendProposalStep",
        formRef,
      });
    } catch (error: any) {
      console.log({ ...error });
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErros(error);
        formRef.current?.setErrors(reduceFormErrors(formRef, errors));
      }

      handleErrorMessage({
        errorCatch: error,
        fieldName: "password",
        formRef,
      });
    }
  };

  const sendSubmitProposal = async () => {
    try {
      const variables = {
        proposal_id: proposalId,
        step: "submit_to_identity_analysis",
      };

      const response = await sendStepProposal({
        variables,
      });

      console.log("sendSubmitProposal", response);

      const status = response?.data?.SendProposalStep?.status;

      if (status === "identity_analysis") {
        const quiz = response?.data?.SendProposalStep?.quiz;
        history.replace({ pathname: "/quiz", state: { quiz, proposalId } });
        return;
      }

      let type = ScreensEnum.RESGISTRATION_DENIED;

      if (status === "approved_topups") {
        type = ScreensEnum.RESGISTRATION_PERFORMED;
      }

      history.replace({
        pathname: "/feedback",
        state: { type, origin: "/signup" },
      });
    } catch (error: any) {
      console.log({ ...error });
      handleErrorMessage({
        errorCatch: error,
        fieldName: "password",
        formRef,
      });
    }
  };

  const onSubmit = async () => {
    setLoadingSendPassword(true);

    const sendPassword = await handleSendStepProposalPassword();
    if (!sendPassword) {
      setLoadingSendPassword(false);
      return;
    }

    await sendSubmitProposal();
    setLoadingSendPassword(false);
  };

  const handleUsernameInput = useCallback(
    () =>
      handleSendStepProposal({
        name: "username",
        formatField: formatFieldUsername,
        setEnableNextInput: () => {
          setDisabledBirthdate(false);
          setDisabledPassword(false);
        },
        focusNextInput: focusInput("password"),
        stepToFillProposal: "fill_in_username",
        stepProposalFilled: "awaiting_username",
        validateSuccess: {
          status: "identity_analysis",
          step: "awaiting_password",
        },
        validateInput: validateInput({ name: "username" }),
        errorMessage,
        formRef,
        proposalId,
        setStepFieldId: setStepUsernameId,
        stepFieldId: stepUsernameId,
      })(),
    [focusInput, handleSendStepProposal, proposalId, stepUsernameId]
  );

  const inputs = [
    {
      input: {
        name: "cpf",
        mask: "999.999.999-99",
        labelText: "Qual o seu CPF?",
        placeholder: "CPF",
        onChange: onChange({
          formRef,
          name: "cpf",
          length: 11,
          handleValidation: handleSubmitCPF,
        }),
        disabled: disabledCPF,
      },
      tooltip: {
        content:
          "Para atender as normas Brasileira de carteiras digitais. Fique tranquilo ninguém tem acesso a ele.",
        title: "Porque pedimos seu CPF?",
      },
    },
    {
      input: {
        name: "birthdate",
        mask: "99/99/9999",
        labelText: "Quando você nasceu?",
        placeholder: "00/00/0000",
        onChange: onChange({
          formRef,
          name: "birthdate",
          length: 8,
          handleValidation: handleSendStepProposal({
            name: "birthdate",
            formatField: formatFieldBirhdate,
            setEnableNextInput: () => setDisabledCellphone(false),
            stepToFillProposal: "fill_in_birthdate",
            validateSuccess: {
              status: "identity_analysis",
              step: "awaiting_cellphone_number",
            },
            validateInput: validateInput({ name: "birthdate" }),
            focusNextInput: focusInput("cell_phone_number"),
            errorMessage,
            formRef,
            proposalId,
            setStepFieldId: setStepBirthdateId,
            stepFieldId: stepBirthdateId,
            stepProposalFilled: "awaiting_birthdate",
            setDisabledField: () => setDisabledBirthdate(true),
          }),
        }),
        disabled: disabledBirthdate,
      },
    },
    {
      input: {
        name: "cell_phone_number",
        mask: "(99) \\9 9999-9999",
        labelText: "Qual é o seu número de celular?",
        placeholder: "(00) 0 0000-0000",
        onChange: onChange({
          formRef,
          name: "cell_phone_number",
          length: 11,
          handleValidation: handleSendStepProposal({
            name: "cell_phone_number",
            formatField: formatFieldCellphone,
            stepToFillProposal: "fill_in_cellphone_number",
            stepProposalFilled: "awaiting_cellphone_number_validation",
            validateSuccess: {
              status: "identity_analysis",
              step: "awaiting_cellphone_number_validation",
            },
            validateInput: validateInput({ name: "cell_phone_number" }),
            errorMessage,
            formRef,
            proposalId,
            openModal,
            setStepFieldId: setStepCellphoneId,
            stepFieldId: stepCellphoneId,
          }),
        }),
        disabled: disabledCellphone,
      },
      tooltip: {
        content: "",
        title: "Enviaremos um código SMS para validar sua conta",
      },
    },
    {
      input: {
        name: "username",
        mask: "",
        labelText: "Crie o nome do usuário:",
        placeholder: "NomeExemplo",
        onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => {
          if (event.key === "Enter") {
            handleUsernameInput();
          }
        },
        onBlur: handleUsernameInput,
        disabled: disabledUsername,
      },
    },
    {
      input: {
        name: "password",
        type: "password",
        mask: "",
        maxLength: 8,
        labelText: "Agora crie uma senha:",
        placeholder: "••••••••",
        onChange: onChangePassword({
          formRef,
          name: "password",
          setStatePassword: setPassword,
        }),
        onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => {
          if (event.code === "Enter") {
            onSubmit();
          }
        },
        disabled: disabledPassword,
      },
      value: password,
    },
  ];

  const handlers: UserDataScreenProps = {
    title: "Conecte-se à RV Digital: ",
    subtitle: "Preencha todos os campos conforme forem liberados! ",
    inputs,
    formRef,
    countdownRef,
    handleSubmit: onSubmit,
    inputTokens,
    setInputToken,
    handleSendStepProposalToken,
    showModal,
    closeModal,
    loadingResendToken,
    handleResendToken,
    loadingSendPassword,
    disabledSendPassword:
      disabledBirthdate &&
      disabledCellphone &&
      disabledUsername &&
      disabledPassword,
  };

  return <UserDataScreen {...handlers} />;
};
